import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export const refUpdater = ({ checked, indeterminate }) => input => {
  if (input) {
    input.checked = checked
    input.indeterminate = indeterminate
  }
}

class Checkbox extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
  }

  render() {
    const { checked, indeterminate = false, onChange, disabled, readOnly, ...rest } = this.props

    const isDisabled = disabled || readOnly

    return (
      <label className={`inline-flex items-center cursor-pointer `}>
        <input
          type="checkbox"
          ref={refUpdater({ checked, indeterminate })}
          onChange={onChange}
          disabled={isDisabled}
          style={{ display: 'none' }}
          {...rest}
        />

        <span
          className={`w-5 h-5 border-2 rounded ${
            checked ? 'border-primary' : 'border-gray-500'
          } inline-block mr-2 relative`}
        >
          {checked && (
            <svg
              className="fill-current text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              width="12"
              height="12"
            >
              <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
          )}

          {indeterminate && (
            <svg
              className="fill-current text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              width="12"
              height="12"
            >
              <rect
                x="3"
                y="3"
                width="14"
                height="14"
                rx="2"
                fill="#808080" // Brown background color
                stroke="#808080" // Border color (same as background color)
                strokeWidth="2"
              />
            </svg>
          )}
        </span>
      </label>
    )
  }
}

export default Checkbox
